/* @blood-tests-v1 — Εξετάσεις αίματος, admin report.
 * NO CLINICAL CONTENT: money, outcomes and timings only. No test names or answers. */
import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { bloodTestsAdminAPI } from '../services/api';

const th = { textAlign: 'left', padding: '10px 12px', fontSize: 12, color: '#6b7280', fontWeight: 700, borderBottom: '1px solid #e5e7eb', whiteSpace: 'nowrap' };
const td = { padding: '10px 12px', fontSize: 13, borderBottom: '1px solid #f1f5f9' };
const thisMonth = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`; };
const monthRange = (ym) => { const [y, m] = ym.split('-').map(Number); return [`${ym}-01`, `${ym}-${String(new Date(Date.UTC(y, m, 0)).getUTCDate()).padStart(2, '0')}`]; };
const fmt = (d) => (d ? new Date(d).toLocaleString('el-GR', { timeZone: 'Europe/Athens', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—');
const euros = (n) => `€${Number(n || 0).toFixed(2)}`;
const mins = (m) => (m == null ? '—' : m < 60 ? `${m}′` : `${Math.floor(m / 60)}ω ${m % 60}′`);
const STATUS = { open: 'Στην ουρά', claimed: 'Σε εξέλιξη', info_requested: 'Αναμονή ασθενή', completed: 'Ολοκληρώθηκε', closed_no_reply: 'Χωρίς απάντηση ασθενή' };
const DECISION = { issued: 'Εκδόθηκε', declined: 'Άρνηση', referred: 'Παραπομπή' };
const Stat = ({ value, label }) => (
  <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: '12px 16px', minWidth: 130, flex: '1 1 130px' }}>
    <div style={{ fontSize: 22, fontWeight: 700, color: '#0F1F3D' }}>{value}</div>
    <div style={{ fontSize: 12, color: '#6b7280' }}>{label}</div>
  </div>
);

export default function BloodTestsReportPage() {
  const [month, setMonth] = useState(thisMonth());
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    const [from, to] = monthRange(month);
    bloodTestsAdminAPI.list({ from, to })
      .then((r) => { if (!cancelled) setData(r.data?.data || null); })
      .catch(() => { if (!cancelled) { setData(null); toast.error('Αδυναμία φόρτωσης αιτημάτων'); } })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [month]);
  const s = data?.summary;
  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12, marginBottom: 16 }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 700, margin: 0 }}>Εξετάσεις Αίματος</h1>
          <p style={{ color: '#6b7280', fontSize: 13, margin: '6px 0 0' }}>Αιτήματα που πληρώθηκαν τον μήνα (ώρα Αθήνας). Χωρίς κλινικά στοιχεία.</p>
        </div>
        <label style={{ fontSize: 13 }}>Μήνας{' '}
          <input type="month" value={month} onChange={(e) => e.target.value && setMonth(e.target.value)} style={{ padding: '6px 8px', border: '1px solid #d1d5db', borderRadius: 6 }} />
        </label>
      </div>
      {loading && <p>Φόρτωση…</p>}
      {s && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginBottom: 16 }}>
          <Stat value={s.paid} label="Πληρωμένα" />
          <Stat value={s.waiting} label="Σε εκκρεμότητα" />
          <Stat value={s.issued} label="Εκδόθηκαν" />
          <Stat value={s.declined + s.referred} label="Άρνηση / παραπομπή" />
          <Stat value={euros(s.revenueEuros)} label="Έσοδα" />
          <Stat value={euros(s.platformEuros)} label="Μερίδιο DocNow" />
        </div>
      )}
      {data && (
        <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr>{['Πληρωμή', 'Ασθενής', 'Γιατρός', 'Πακέτο', 'Κατάσταση', 'Απόφαση', 'Χρόνος', 'Ποσό', 'Γιατρός €', 'DocNow €'].map((h) => <th key={h} style={th}>{h}</th>)}</tr></thead>
            <tbody>
              {data.requests.length === 0 && <tr><td style={td} colSpan={10}>Κανένα αίτημα.</td></tr>}
              {data.requests.map((r) => (
                <tr key={r.id}>
                  <td style={td}>{fmt(r.paidAt)}</td><td style={td}>{r.patientName}</td><td style={td}>{r.doctorName || '—'}</td>
                  <td style={td}>{r.packageName}</td><td style={td}>{STATUS[r.status] || r.status}</td>
                  <td style={td}>{DECISION[r.decision] || '—'}{r.referralEmailFailed ? ' · ΔΕΝ ΣΤΑΛΘΗΚΕ PDF' : ''}</td>
                  <td style={td}>{mins(r.minutesToDecision)}</td><td style={td}>{euros(r.amountEuros)}</td>
                  <td style={td}>{euros(r.doctorEuros)}</td><td style={td}>{euros(r.platformEuros)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
